/**
 *
 *@author xujinjiang
 *@date 2022/3/2 11:24
 */

import { BaseServiceImpl } from '@/service/BaseServiceImpl';
import { HomeUrlConfig } from '@/config/HomeUrlConfig';

export class HomeServiceImpl extends BaseServiceImpl {
  private static service: HomeServiceImpl;

  public static getInstance(): HomeServiceImpl {
    if (HomeServiceImpl.service == null) {
      HomeServiceImpl.service = new HomeServiceImpl();
    }

    return HomeServiceImpl.service;
  }

  /**
   * 获取用户信息
   * @param id
   */
  getUserInfo(id: string): Promise<any> {
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const self = this;
    const option = BaseServiceImpl.getGetOption();
    option.url = HomeUrlConfig.getUserInfo;
    option.params = {
      id: id
    };
    return new Promise((resolve, reject) => {
      self
        .huohuaRequest(option)
        .then(function (res) {
          resolve(res.data);
        })
        .catch(function (error) {
          reject(error);
        });
    });
  }

  /**
   * 获取登录日志
   * @param userId
   * @param pageNo
   * @param pageSize
   */
  getUserLoginLog(userId: string, pageNo: any, pageSize: any) {
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const self = this;
    const option = BaseServiceImpl.getGetOption();
    option.url = HomeUrlConfig.getUserLoginLog;
    option.params = {
      userId: userId,
      pageNo: pageNo,
      pageSize: pageSize
    };
    return new Promise((resolve, reject) => {
      self
        .huohuaRequest(option)
        .then(function (res) {
          resolve(res.data.logList);
        })
        .catch(function (error) {
          reject(error);
        });
    });
  }

  logout() {
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const self = this;
    const option = BaseServiceImpl.getPostOption();
    option.url = HomeUrlConfig.logout;
    return new Promise((resolve, reject) => {
      self
        .huohuaRequest(option)
        .then(function (res) {
          resolve(res.data.logList);
        })
        .catch(function (error) {
          reject(error);
        });
    });
  }
}
